import { i18next } from '@/i18n'

export default {
  path: 'annonces-commerciaux/',
  name: 'annonces-commerciaux',
  meta: {
    auth: 'ROLE_USER',
    title: i18next.t('layouts.annoncesCommerciaux')
  },
  component: () =>
    import(/* webpackChunkName: "posts" */ '../pages/annoncesCommerciaux/annoncesCommerciaux.vue')
}
